import type { routes } from '@semios/app-platform-banyan-route-definitions'
import { isNil } from '@semios/app-platform-common'
import type { VV } from '@semios/app-platform-value-type-definitions'
import { selectedPropertyHasPermission } from 'App/Map/PanelDetails/_utils/selectedPropertyHasPermission'
import type { StackedChartSection } from 'components/StackedChart/types'
import { selectedFieldAssetsStore } from 'stores/selectedFieldAssetsStore/selectedFieldAssetsStore'
import type { selectedValueGroupsStore } from 'stores/selectedValueGroupsStore/selectedValueGroupsStore'
import { wmActivity } from './wmActivity'
import { wmBattery } from './wmBattery'
import { wmRunTime } from './wmRunTime'

const valueTypes: VV.DomainTypes.WindMachine.TTimeseriesValueTypeKeysMerged[] = [
  'windMachineRPM',
  'windMachineBattery',
  'windMachineFuel',
  'windMachineTemperature',
  'windMachineActivity',
  'windMachineSettings',
  'windMachineActivityIntervals',
]

const preferredAggregationInterval = { preferredAggregationInterval: 'UNAGGREGATED' }

const checkPermission = () =>
  selectedPropertyHasPermission({ permission: 'VIEW_CONTROLLABLE_FROST_FAN_DETAILS' })

export const apiArgs = ({
  selectedValueGroups,
}: {
  selectedValueGroups: ReturnType<typeof selectedValueGroupsStore.getState>['selectedValueGroups']
}): Partial<routes.Values.Request> => {
  if (!checkPermission()) return {}

  const selectedWindMachine = selectedFieldAssetsStore.getState().windMachinePoint

  if (!selectedValueGroups.wind_machine || isNil(selectedWindMachine)) {
    return {}
  }

  const valuesRequested = Object.fromEntries(
    valueTypes.map((valueType) => [valueType, preferredAggregationInterval]),
  )

  return {
    points: {
      lngLats: [selectedWindMachine],
      valuesRequested,
    },
  }
}

export const content = ({ data }: { data: routes.Values.Response }): StackedChartSection[] => {
  const windMachineLngLat = selectedFieldAssetsStore.getState().windMachinePoint
  const windMachineCharts = []

  windMachineCharts.push(wmRunTime({ data, windMachineLngLat, valueTypes }))

  windMachineCharts.push(wmActivity({ data, windMachineLngLat, valueTypes }))

  windMachineCharts.push(wmBattery({ data, windMachineLngLat, valueTypes }))

  return windMachineCharts
}
